import { mutations } from "../store/Bootstrap";

const Bootstrap = {
  install(Vue) {
    Vue.directive("bs-modal", {
      bind: (el, binding) => {
        el.addEventListener("click", e => {
          mutations.showModal(binding.value);
          e.preventDefault();
        });
      }
    });

    Vue.directive("bs-tab", {
      bind: el => {
        el.addEventListener("click", e => {
          const tabEls = document.querySelectorAll('[data-toggle="tab"]');
          const tabContentEls = document.querySelectorAll(".tab-pane");

          const target = el.getAttribute("href");
          const targetEl = document.querySelector(target);

          if (!tabEls.length || !tabContentEls.length || !targetEl) {
            return;
          }

          const tabElNodes = Array.prototype.slice.call(tabEls, 0);
          tabElNodes.forEach(tabEl => {
            tabEl.classList.remove("active");
          });

          const tabContentElNodes = Array.prototype.slice.call(
            tabContentEls,
            0
          );
          tabContentElNodes.forEach(tabContentEl => {
            tabContentEl.classList.remove("active");
          });

          el.classList.add("active");
          targetEl.classList.add("active");
          e.preventDefault();
        });
      }
    });

    Vue.directive("bs-transition", {
      bind: el => {
        el.addEventListener("click", () => {
          const tabEls = document.querySelectorAll(
            '[data-toggle="transition"]'
          );
          const tabContentEls = document.querySelectorAll(".item_transition");

          const target = el.getAttribute("data-href");
          const targetEl = document.querySelector(target);

          if (!tabEls.length || !tabContentEls.length || !targetEl) {
            return;
          }

          const tabElNodes = Array.prototype.slice.call(tabEls, 0);
          tabElNodes.forEach(tabEl => {
            tabEl.classList.remove("active");
          });

          const tabContentElNodes = Array.prototype.slice.call(
            tabContentEls,
            0
          );
          tabContentElNodes.forEach(tabContentEl => {
            tabContentEl.classList.remove("active");
            tabContentEl.style.display = "none";
          });

          el.classList.add("active");
          targetEl.classList.add("active");
          targetEl.style.display = "block";
          // e.preventDefault();
        });
      }
    });

    Vue.directive("bs-toggle", {
      bind: el => {
        el.addEventListener("close", () => {
          const tabContent = el.nextElementSibling;
          el.classList.remove("active");
          tabContent.style.display = "none";
        });

        el.addEventListener("click", e => {
          const tabContent = el.nextElementSibling;

          if (el.classList.contains("active")) {
            el.classList.remove("active");

            tabContent.style.display = "none";
          } else {
            el.classList.add("active");

            tabContent.style.display = "block";
          }

          e.preventDefault();
        });
      }
    });

    const toolTipEventListener = (el, binding) => {
      let tooltipElement = null;
      let timer = null;

      if (el._mouseenter_handler) {
        el.removeEventListener("mouseenter", el._mouseenter_handler);
      }
      if (el._mouseleave_handler) {
        el.removeEventListener("mouseleave", el._mouseleave_handler);
      }

      el._mouseenter_handler = e => {
        if (timer !== null) {
          clearTimeout(timer);
        }
        if (tooltipElement !== null) {
          document.body.removeChild(tooltipElement);
          tooltipElement = null;
        }
        if (!binding.value) {
          return;
        }

        tooltipElement = document.createElement("div");
        tooltipElement.className = "tooltip fade bs-tooltip-top";

        const toolTipArrowElement = document.createElement("div");
        toolTipArrowElement.className = "arrow";
        tooltipElement.appendChild(toolTipArrowElement);

        const toolTipInnerElement = document.createElement("div");
        toolTipInnerElement.className = "tooltip-inner";
        toolTipInnerElement.textContent = binding.value;
        tooltipElement.appendChild(toolTipInnerElement);

        document.body.appendChild(tooltipElement);

        // Calc the position
        const parentRect = el.getBoundingClientRect();
        const toolTipRect = tooltipElement.getBoundingClientRect();
        const x =
          parentRect.left +
          window.pageXOffset +
          parentRect.width / 2 -
          toolTipRect.width / 2;
        const y = parentRect.top + window.pageYOffset - toolTipRect.height;
        tooltipElement.style.position = "absolute";
        tooltipElement.style.top = "0px";
        tooltipElement.style.left = "0px";
        tooltipElement.style.willChange = "transform";
        tooltipElement.style.transform = `translate3d(${x}px, ${y}px, 0px)`;

        // Arrow position
        toolTipArrowElement.style.left = `${toolTipRect.width / 2}px`;

        // Animating
        timer = setTimeout(() => {
          if (tooltipElement !== null) {
            tooltipElement.classList.add("show");
          }
        }, 10);

        e.preventDefault();
      };

      el._mouseleave_handler = e => {
        if (timer !== null) {
          clearTimeout(timer);
        }

        if (tooltipElement !== null) {
          tooltipElement.classList.remove("show");

          // Animating
          timer = setTimeout(() => {
            if (tooltipElement !== null) {
              document.body.removeChild(tooltipElement);
              tooltipElement = null;
            }
          }, 150);
        }

        e.preventDefault();
      };

      el.addEventListener("mouseenter", el._mouseenter_handler);
      el.addEventListener("mouseleave", el._mouseleave_handler);
    };

    Vue.directive("bs-tooltip", {
      bind: (el, binding) => {
        toolTipEventListener(el, binding);
      },
      componentUpdated: (el, binding) => {
        toolTipEventListener(el, binding);
      }
    });

    Vue.prototype.$bootstrap = {
      showModal: key => {
        mutations.showModal(key);
      },
      hideModal: key => {
        mutations.hideModal(key);
      }
    };
  }
};

export default Bootstrap;
